import { Topbar } from './Topbar'
import { WelcomeVideo } from '@/components/molecules/Admin/Modals/OnboardingStudent/WelcomeVideo'
import { Calendar } from '@/components/molecules/Admin/Modals/OnboardingStudent/Calendar'
import { Whatsapp } from '@/components/molecules/Admin/Modals/Whatsapp'
import Notification from '@/components/molecules/Admin/Notification'
import { NewJourney } from '@/components/molecules/Admin/Modals/NewJourney'
import { ProgressCheck } from '@/components/molecules/Admin/Modals/ProgressCheck'

interface ProgressCheckProps {
	children: React.ReactNode
}

export function ProgressCheckLayout({ children }: ProgressCheckProps) {
	return (
		<div className='w-full flex flex-col justify-center items-center bg-zinc-950'>
			<Topbar />
			<div className='flex flex-col w-full min-h-[85vh] overflow-clip relative'>
				{children}
			</div>

			<Notification />

			{/* start of student onboarding */}
			<WelcomeVideo disabledOnClose />
			<Calendar disabledOnClose />
			{/* end of student onboarding */}

			<Whatsapp disabledOnClose />
			<ProgressCheck />

			<NewJourney />
		</div>
	)
}
